import * as React from 'react';
import { Create, SimpleForm, TextInput, required, TranslatableInputs } from "react-admin";
import { locales } from "../enum/locales";

export const TranslationsCreateForm = () => (
  <SimpleForm>
    <TextInput source="code" validate={[required()]} />
    <TranslatableInputs locales={locales} defaultLocale="en" fullWidth={true}>
      <TextInput source="translation" validate={[required()]} fullWidth multiline />
    </TranslatableInputs>
  </SimpleForm>
);

export const TranslationsCreate = () => (
  <Create>
    <TranslationsCreateForm />
  </Create>
);
